import React, { useEffect, useState } from "react";
import format from "date-fns/format";
import { DateRange } from "react-date-range";
import Icon from "../Detail/Icons";
import { useDetectClickOutside } from "react-detect-click-outside";
import useWindowSize from "../windowDimension";
import useLocale from "../../helper/useLocale";
import { useTranslation } from "../../context/TranslationContext";

const FormDatepicker = ({ state2, setState2, dates, setError }) => {
  const localeData = useLocale();
  const { datepickerCheckIn, datepickerCheckOut } = useTranslation();
  const [dayStart, setdayStart] = useState(format(state2[0].startDate, "dd"));
  const [dayEnd, setdayEnd] = useState(format(state2[0].endDate, "dd"));
  const [isShow, setIsShow] = useState(false);

  const [doluGirisler, setDoluGirisler] = useState([]);
  const [doluCikislar, setDoluCikislar] = useState([]);
  const [doluGunler, setDoluGunler] = useState([]);
  const [odemeGirisler, setOdemeGirisler] = useState([]);
  const [odemeCikislar, setOdemeCikislar] = useState([]);
  const [odemeGunler, setOdemeGunler] = useState([]);

  const [monthStart, setmonthStart] = useState();
  const [monthEnd, setmonthEnd] = useState();

  const { width } = useWindowSize();

  function ToggleShow() {
    setIsShow(!isShow);
  }
  function CloseToggle() {
    setIsShow(false);
  }

  function onChange(item) {
    setState2([item.selection]);
    setError(false);
    if (item.selection.startDate !== item.selection.endDate) {
      CloseToggle();
    }
  }

  function customDayContent(day) {
    const classname = null;
    if (
      doluGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0 &&
      doluCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluGirdiCikti";
    } else if (
      doluGunler?.filter((x) => day.toDateString() == x.toDateString()).length >
      0
    ) {
      classname = "doluGunler";
    } else if (
      doluCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluCikis";
    } else if (
      doluGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "doluGiris";
    } else if (
      odemeGirisler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeGiris";
    } else if (
      odemeCikislar?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeCikis";
    } else if (
      odemeGunler?.filter((x) => day.toDateString() == x.toDateString())
        .length > 0
    ) {
      classname = "odemeGunler";
    }
    return (
      <div className={`absolute inset-0 ${classname}`}>
        <span className="text-white">{format(day, "d")}</span>
      </div>
    );
  }

  useEffect(() => {
    setDoluGunler(dates.doluGunler?.map((e) => new Date(e)));
    setDoluGirisler(dates.doluGirisler?.map((e) => new Date(e)));
    setDoluCikislar(dates.doluCikislar?.map((e) => new Date(e)));
    setOdemeGunler(dates.odemeGunler?.map((e) => new Date(e)));
    setOdemeGirisler(dates.odemeGirisler?.map((e) => new Date(e)));
    setOdemeCikislar(dates.odemeCikislar?.map((e) => new Date(e)));
  }, [dates]);

  useEffect(() => {
    setdayStart(format(state2[0].startDate, "dd"));
    setdayEnd(format(state2[0].endDate, "dd"));
    setmonthStart(format(state2[0].startDate, "MMM", { locale: localeData }));
    setmonthEnd(format(state2[0].endDate, "MMM", { locale: localeData }));
  }, [state2, localeData]);

  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  return (
    <div
      className="bg-white pt-4 pb-1 ml:py-5 pl-7 pr-5 flex items-center relative"
      ref={ref}
    >
      <div
        className="flex justify-between flex-1 mr-10 items-center cursor-pointer"
        onClick={(e) => {
          ToggleShow();
        }}
      >
        <div className="flex flex-col">
          <span className="font-bold text-brand-gray-2 text-13">
            {datepickerCheckIn}
          </span>
          <span className="font-bold text-xl">
            {dayStart}{" "}
            <span className="text-xs -top-0.5 relative inline-block">
              {monthStart}
            </span>
          </span>
        </div>
        <Icon name={"DatepickerMiddle"}></Icon>
        <div className="flex flex-col">
          <span className="font-bold text-brand-gray-2 text-13">
            {datepickerCheckOut}
          </span>
          <span className="font-bold text-xl">
            {dayEnd}{" "}
            <span className="text-xs -top-0.5 relative inline-block">
              {monthEnd}
            </span>
          </span>
        </div>
      </div>
      <Icon name={"DatepickerArrows"}></Icon>
      <div
        className={
          "absolute  z-20 flex-col py-5 pl-8 pr-7 bg-white w-full left-0 top-full border DatePickerFullWidth  " +
          (isShow ? "flex" : "hidden")
        }
      >
        {localeData && (
          <DateRange
            editableDateInputs={false}
            onChange={(item) => onChange(item)}
            moveRangeOnFirstSelection={false}
            ranges={state2}
            showDateDisplay={false}
            disabledDates={doluGunler}
            locale={localeData}
            months={width < 640 ? 1 : width < 768 ? 2 : width < 1024 ? 3 : 1}
            minDate={new Date()}
            showMonthAndYearPickers={false}
            direction="horizontal"
            dayContentRenderer={customDayContent}
            className="availability-calendar"
          />
        )}
      </div>
    </div>
  );
};

export default FormDatepicker;
